// Back returns to where the person was on the page (release 3.3, Back model
// B6 of the 7 Oct plan).
//
// Every move between addresses used to scroll to the top, so Back from a
// vendor opened halfway down a list landed at the top of the list. Now each
// history entry carries a key in its state, and the scroll position is kept
// against that key as the person scrolls. Arriving at an entry that has a key
// (Back or Forward) goes back to its position, once the page has drawn enough
// to reach it; arriving at a new entry starts at the top.

const STORE = 'tprm.scroll'
let places: Record<string, number> = read()

function read(): Record<string, number> {
  try {
    const raw = sessionStorage.getItem(STORE)
    const v = raw ? (JSON.parse(raw) as unknown) : {}
    return v && typeof v === 'object' ? (v as Record<string, number>) : {}
  } catch {
    return {}
  }
}

function write(): void {
  try {
    sessionStorage.setItem(STORE, JSON.stringify(places))
  } catch {
    // Storage refused: the position is kept for this page only.
  }
}

function entryKey(): string {
  try {
    return String(((history.state ?? {}) as { k?: unknown }).k ?? '')
  } catch {
    return ''
  }
}

function giveKey(): string {
  const k = Math.random().toString(36).slice(2, 10)
  try {
    history.replaceState({ ...((history.state ?? {}) as object), k }, '')
  } catch {
    return ''
  }
  return k
}

let timer = 0
let restoring = 0

// Keeps the position of the entry on screen as the person scrolls. Returns
// the clean-up.
export function keepScrollPlace(): () => void {
  try {
    // The console restores the place itself, after the page has drawn.
    history.scrollRestoration = 'manual'
  } catch {
    // Old browsers: their own restoring stands.
  }
  if (!entryKey()) giveKey()
  const onScroll = () => {
    if (restoring) return
    const k = entryKey()
    if (!k) return
    places[k] = Math.round(window.scrollY)
    // The tab's copy is written a moment later, once the scrolling stops.
    window.clearTimeout(timer)
    timer = window.setTimeout(write, 200)
  }
  window.addEventListener('scroll', onScroll, { passive: true })
  return () => window.removeEventListener('scroll', onScroll)
}

// Called when the address changes. A returning entry goes back to its place
// (the list may still be loading, so it waits up to two seconds for the page
// to grow tall enough); a new one starts at the top.
export function arriveAtEntry(): void {
  // A restore still waiting for the last page to grow belongs to that page.
  window.clearInterval(restoring)
  restoring = 0
  const k = entryKey()
  const y = k ? places[k] : undefined
  if (!k) giveKey()
  if (y === undefined || y <= 0) {
    window.scrollTo(0, 0)
    return
  }
  let tries = 0
  window.clearInterval(restoring)
  const step = () => {
    tries++
    const room = document.documentElement.scrollHeight - window.innerHeight
    if (room >= y || tries >= 20) {
      window.clearInterval(restoring)
      restoring = 0
      window.scrollTo(0, Math.min(y, Math.max(0, room)))
    }
  }
  window.scrollTo(0, 0)
  restoring = window.setInterval(step, 100)
  step()
}
